module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-4-645c6fb966a51a34878800cb2cdd7dfe.svg";